/**
 * Some card networks are only supported by certain Apple Pay API versions.
 *
 * @see https://developer.apple.com/documentation/apple_pay_on_the_web/apple_pay_on_the_web_version_history
 */
const ApplePayNetworksByVersion = {
    amex: 1,
    bancomat: 14,
    bancontact: 14,
    cartesBancaires: 4,
    chinaUnionPay: 1,
    dankort: 13,
    discover: 1,
    eftpos: 4,
    electron: 4,
    elo: 5,
    girocard: 11,
    interac: 1,
    jcb: 2,
    mada: 5,
    maestro: 4,
    masterCard: 1,
    mir: 11,
    privateLabel: 1,
    visa: 1,
    vPay: 4,
} as const;

type ApplePayNetwork = keyof typeof ApplePayNetworksByVersion;

const applePayNetworks = new Set(Object.keys(ApplePayNetworksByVersion));

const isApplePayNetwork = (network: string): network is ApplePayNetwork => applePayNetworks.has(network);

export const reduceNetworksToSupported = (
    version: number,
    request: ApplePayJS.ApplePayPaymentRequest,
): ApplePayJS.ApplePayPaymentRequest => {
    const allNetworks = request.supportedNetworks.length > 0 ? request.supportedNetworks : [...applePayNetworks];

    const supportedNetworks = allNetworks
        .filter(isApplePayNetwork)
        .filter((network) => ApplePayNetworksByVersion[network] <= version);

    return { ...request, supportedNetworks };
};
